import { FlowItem, INamedItem, IOwnedItem, ILuidItem } from './resourceParts';

export type FlowDraft =
  INamedItem &
  FlowItem &
  ILuidItem &
  IOwnedItem & {
  readonly createdAt: string; // YYYY-MM-DDThh:mm:ssZ
  readonly lastUpdatedAt: string; // YYYY-MM-DDThh:mm:ssZ
  readonly downloadUrl?: string;
}

export enum ContentDraftStatus {
  none = 'NONE', // no draft
  unpublished = 'UNPUBLISHED', // never published draft
  unpublishedchanges = 'UNPUBLISHED_CHANGES', // draft

}